import type { ClientInvoiceItemDto } from '../../lib/clientInvoiceApi';
import { num } from '../../utils/invoiceLineMath';

/** The word a stock line shows where the supplier goes (D185.7). Display only: never stored, sent or picked. */
export const INVENTORY_SUPPLIER = 'Inventory';

/** D185.7: no supplier and stock drawn reads "Inventory"; any supplier name keeps showing that name. */
export function readsAsInventory(item: Pick<ClientInvoiceItemDto, 'supplierName' | 'qtyFromStock'>): boolean {
  const fromStock = num(item.qtyFromStock);
  return !String(item.supplierName || '').trim() && fromStock !== null && fromStock > 0;
}
